import { observable, toJS } from 'mobx';

class WebSocketStoreC {
  @observable
  approvedByMeCount = '';
}
export const webSocketStore = new WebSocketStoreC();

['development', 'staging'].includes(process.env.MODE!) ? Object.assign(window, { webSocketStore, toJS }) : void 0;
